import uiActions from '../actions/UIActions';
import reducerUtils from './ReducerUtils';
import UIConstants from '../constants/UIConstants';
import uiService from '../services/UIService';

const defaultState = {
    zoomFactor: UIConstants.ZOOM_FACTOR.SMALL,
    variables: {},
    a11yContrastOptions: uiService.readAccessibilityContrastOptions(),
    direction: 'ltr',
};

export default function (state = defaultState, action) {
    switch (action.type) {
    case uiActions.types.UI_SET_PROPERTIES:
        return reducerUtils.applyProps(state, action.properties);
    case uiActions.types.SET_STIMULUS_STATE:
        return {
            ...state,
            stimulusState: action.state,
        };
    default:
        return state;
    }
}
